import { Route, Routes, NavLink } from 'react-router-dom';
import RequireAuth from '../components/RequireAuth';
import Layout from '../components/Layout/Layout';
import Login from '../components/Login';
import ErrorPage from '../components/404';
import ResetPassword from '../components/ResetPassword';
import ChangeForgottenPassword from '../components/ChangeForgottenPassword';
import SignUp from '../components/SignUp';
import VerifyEmail from '../components/VerifyEmail';
import FindProduct from '../components/FindProduct';
import CheckProduct from '../components/CheckProduct';
import CheckReviews from '../components/CheckReviews';
import CheckBoard from '../components/CheckBoard';
import EditOrCreateReview from '../components/EditOrCreateReview';
import AddProduct from '../components/AddProduct';
import ProductList from '../components/ProductList';
import FormattedPage from '../components/FormattedPage';
import Profile from '../components/Profile/Profile';
import FavoriteProductList from '../components/FavoriteProductList';
import Organizations from '../components/Organizations';
import EditUserOrganization from '../components/EditUserOrganization';
import SignUpOrganization from '../components/SignUpOrganization';
import ProductOrganizationDetails from '../components/ProductOrganizationDetails';
import Organization from '../components/Organization';
import ProductOrganization from '../components/ProductOrganization';
import BrandOrganization from '../components/BrandOrganization';
import UserOrganization from '../components/UserOrganization';
import LotDetails from '../components/Lots/LotDetails';

function App() {
  const components = {
    LinkToHomepage: (
      <NavLink
        to="/"
        style={{
          textDecoration: 'none',
          color: 'inherit',
        }}
      />
    ),
  };

  return (
    <Routes>
      <Route path="/" element={<Layout hasMainNavBar maxContainerWidth="xxl" />}>
        <Route index element={<FindProduct />} />
      </Route>

      <Route element={<Layout maxContainerWidth="sm" />}>
        <Route path="login" element={<Login />} />
        <Route path="registration" element={<SignUp />} />
        <Route path="registration/account-confirm-email" element={<VerifyEmail />} />
        <Route path="registration/account-confirm-email/:key" element={<VerifyEmail />} />
        <Route path="reset/password" element={<ResetPassword />} />
        <Route path="reset/password/:id/:token" element={<ChangeForgottenPassword />} />
        <Route path="*" element={<ErrorPage />} />
        <Route path="signuporganization/:opk/:user_id/:token" element={<SignUpOrganization />} />
      </Route>

      <Route path="products" element={<Layout hasMainNavBar search />}>
        <Route index element={<ProductList />} />
        <Route path=":ean" element={<CheckProduct />} />
        <Route path=":ean/reviews/" element={<CheckReviews />} />
        <Route path=":ean/contents/" element={<CheckBoard />} />
        <Route element={<RequireAuth />}>
          <Route path=":ean/addProduct" element={<AddProduct />} />
          <Route path=":ean/editOrCreateReview" element={<EditOrCreateReview />} />
        </Route>
      </Route>

      <Route path="privacy" element={<Layout hasMainNavBar search />}>
        <Route path="cookie" element={<FormattedPage namepage="cookie" content="pages.cookiepolicy.content" components={components} />} />
      </Route>

      <Route path="profile" element={<Layout hasMainNavBar search maxContainerWidth="xxl" />}>
        <Route element={<RequireAuth />}>
          <Route index element={<Profile />} />
          <Route path="favorites" element={<FavoriteProductList />} />
          <Route path="organizations" element={<Organizations />} />
          <Route path="organizations/:opk/" element={<Organization />}>
            <Route path="products" element={<ProductOrganization />} />
            <Route path="brands" element={<BrandOrganization />} />
            <Route path="users" element={<UserOrganization />} />
          </Route>
          <Route path="organizations/:opk/products/:ean/*" element={<ProductOrganizationDetails />} />
          <Route path="organizations/:opk/products/:ean/lots/:id/*" element={<LotDetails />} />
          <Route path="organizations/:opk/users-add" element={<EditUserOrganization />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
